const Summary = ({ children }: React.PropsWithChildren) => {
    return (
        <div className="bg-yellow-lightest shadow-lg py-5 px-3 flex my-8">
            <div className="relative mt-1 mr-3">
                <span className="absolute border-8 left-6 border-blue z-1 top-6 rotate-45 w-4">
                    {' '}
                </span>
                <div className="bg-blue text-white px-3 py-1 z-2 self-start relative rounded-sm z-0 print-hide">
                    Tip
                </div>
            </div>
            <p className="text-md">{children}</p>
        </div>
    );
};

export default Summary;
